import React, { useEffect, useState } from "react";
import { intl } from "@fidget/common/i18n/TypedIntl";
import { WidgetButton } from "@fidget/common/components/widgetButton/widgetButton";
import { ForgetMeDialog } from "./forgetMeDialog";
import styles from "./widgetMenu.css";

enum MenuItem {
  ForgetMe
}
interface Props {
  forgetMe: () => void;
}

export const WidgetMenu = ({ forgetMe }: Props) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [selectedItem, setSelectedItem] = useState<MenuItem>();
  const [itemsNode, setItemsNode] = useState<HTMLDivElement>();
  const [menuNode, setMenuNode] = useState<HTMLDivElement>();

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutsideMenu, false);

    return () => {
      document.removeEventListener("mousedown", handleClickOutsideMenu, false);
    };
  }, [itemsNode]);

  const onThreeDotClick = () => {
    setIsOpen(!isOpen);
  };

  const onItemSelect = (item: MenuItem | undefined) => {
    setIsOpen(false);
    setSelectedItem(item);
  };

  const handleClickOutsideMenu = (event: Event) => {
    if (
      isOpen &&
      itemsNode &&
      menuNode &&
      !itemsNode.contains(event.target as Node) &&
      !menuNode.contains(event.target as Node)
    ) {
      setIsOpen(false);
    }
  };

  const render = () => {
    return (
      <div className={styles["menu-container"]} ref={(el) => setMenuNode(el || undefined)}>
        <WidgetButton icon={"icon-menu-more"} onClick={onThreeDotClick} buttonStyle={"plain"} />
        {isOpen && (
          <div className={styles["items-container"]} ref={(el) => setItemsNode(el || undefined)}>
            <WidgetButton
              icon={"icon-icon-history"}
              onClick={() => onItemSelect(MenuItem.ForgetMe)}
              buttonStyle={"plain"}
            >
              {intl.formatMessage("widget.forgetMe.action")}
            </WidgetButton>
          </div>
        )}

        <ForgetMeDialog
          finish={() => {
            onItemSelect(undefined);
            forgetMe();
          }}
          close={() => onItemSelect(undefined)}
          isOpen={selectedItem === MenuItem.ForgetMe}
        />
      </div>
    );
  };

  return render();
};
